var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "teacher_revenue",
          route_grid_path: "/grid",
          order_column: "order_date",
          direction: "desc",
          "show-export": true,
          "export-types": ["csv", "xls"],
          "export-filename": "hubee_teacher_revenue",
          "fetch-on-mounted": false,
          hide_actions: "true",
          hide_searchbar: "true",
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function () {
              return [
                _c("FinancialPeriodFilter", {
                  attrs: {
                    "show-people-filter": true,
                    "show-institution-filter": false,
                    "people-filter-type": "teacher",
                  },
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "gridThead",
            fn: function () {
              return [
                _c(
                  "vs-th",
                  {
                    key: "teacher_name",
                    attrs: { "sort-key": "teacher_name" },
                  },
                  [_vm._v("Professor")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "teacher_email",
                    attrs: { "sort-key": "teacher_email" },
                  },
                  [_vm._v("Email do Professor")]
                ),
                _c(
                  "vs-th",
                  { key: "order_id", attrs: { "sort-key": "order_id" } },
                  [_vm._v("ID Pedido")]
                ),
                _c(
                  "vs-th",
                  { key: "order_date", attrs: { "sort-key": "order_date" } },
                  [_vm._v("Data do Pedido")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "payment_date",
                    attrs: { "sort-key": "payment_date" },
                  },
                  [_vm._v("Data do Pagamento")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "payment_status",
                    attrs: { "sort-key": "payment_status" },
                  },
                  [_vm._v("Status do Pagamento")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "total_amount",
                    attrs: { "sort-key": "total_amount" },
                  },
                  [_vm._v("Valor Total")]
                ),
                _c(
                  "vs-th",
                  { key: "paid_amount", attrs: { "sort-key": "paid_amount" } },
                  [_vm._v("Valor Recebido")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c(
                      "vs-td",
                      { key: "teacher_name", attrs: { width: "15%" } },
                      [
                        _c("div", { staticClass: "font-semibold" }, [
                          _vm._v(_vm._s(tr.teacher_name)),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "teacher_email", attrs: { width: "15%" } },
                      [_c("div", [_vm._v(_vm._s(tr.teacher_email))])]
                    ),
                    _c("vs-td", { key: "order_id", attrs: { width: "8%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.order_id))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "order_date", attrs: { width: "12%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatDate(tr.order_date))),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "payment_date", attrs: { width: "12%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatDate(tr.payment_date))),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "payment_status", attrs: { width: "12%" } },
                      [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatPaymentStatus(tr.payment_status))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "total_amount", attrs: { width: "13%" } },
                      [
                        _c("span", { staticClass: "font-semibold" }, [
                          _vm._v(_vm._s(_vm.formatCurrency(tr.total_amount))),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "paid_amount", attrs: { width: "13%" } },
                      [
                        _c(
                          "span",
                          { staticClass: "font-semibold text-success" },
                          [_vm._v(_vm._s(_vm.formatCurrency(tr.paid_amount)))]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }